import React from 'react';
import PropTypes from 'prop-types';
import { useDividerGradient } from '../gradient-utils';

export function CurveDouble({
  className,
  depth = 50,
  position = 50,
  fadeOpacity,
  fadeDirection,
  softness,
  style
}) {
  const { defs, fill, mask } = useDividerGradient({ fadeOpacity, fadeDirection, softness });

  // depth controls curve intensity
  const offset = (depth / 100) * 60;
  const top = 60 - offset; // convex (bulge up)
  const bottom = 60 + offset; // concave (dip down)

  // position flips the S-curve direction
  const p = position / 100;
  const leftY = bottom + (top - bottom) * p;
  const rightY = top + (bottom - top) * p;

  return (
    <svg
      className={ className }
      style={ style }
      viewBox='0 0 1200 120'
      preserveAspectRatio='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      { defs }
      <path
        d={ `M0,60 Q300,${leftY} 600,60 Q900,${rightY} 1200,60 L1200,120 L0,120 Z` }
        fill={ fill }
        mask={ mask }
      />
    </svg>
  );
}

CurveDouble.propTypes = {
  className: PropTypes.string,
  depth: PropTypes.number,
  position: PropTypes.number,
  fadeOpacity: PropTypes.number,
  fadeDirection: PropTypes.oneOf(['down', 'up', 'left', 'right']),
  softness: PropTypes.number
};
